import React from "react";
import { useNavigate } from "react-router-dom";
import { Award, ChevronRight, Download, Gift } from "lucide-react";
import { Winner } from "../../../../Redux/luckydraw/types";
import {
  formatGiftCurrency,
  formatStuffDate,
  formatStuffLongDate,
  mapWinnerToGiftRecord,
  toClassSlug,
  GiftRewardStatus,
} from "../stuffAdapters";

interface GiftsTableProps {
  gifts: Winner[];
  startIndex?: number;
}

const renderGiftStatus = (status: GiftRewardStatus) => (
  <span className={`gifts-status gifts-status-${toClassSlug(status)}`}>
    {status}
  </span>
);

const GiftsTable: React.FC<GiftsTableProps> = ({ gifts, startIndex = 0 }) => {
  const navigate = useNavigate();
  const records = gifts.map((gift, i) =>
    mapWinnerToGiftRecord(gift, startIndex + i),
  );

  return (
    <>
      <div className="gifts-desktop-table-wrap">
        <table className="gifts-desktop-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>WON DATE</th>
              <th>LUCKY DRAW</th>
              <th>GIFT DETAILS</th>
              <th>ACHIEVEMENT REWARD</th>
              <th>TITLE</th>
              <th>RECEIPT</th>
            </tr>
          </thead>
          <tbody>
            {records.length > 0 ? (
              records.map((gift) => (
                <tr key={gift.id}>
                  <td className="gifts-serial-cell">{gift.serialNo}</td>
                  <td className="gifts-order-date-cell">
                    <strong>{formatStuffDate(gift.orderDate)}</strong>
                    <small>{gift.orderTime}</small>
                  </td>
                  <td>
                    <div className="gifts-table-stack">
                      <p>
                        <b>Name :</b> {gift.milestone}
                      </p>
                    </div>
                  </td>
                  <td>
                    <div className="gifts-product-details-cell">
                      <div className="gifts-table-product-top">
                        <div className="gifts-table-product-image">
                          <img src={gift.productImage} alt="" />
                        </div>
                        <div>
                          <p>
                            <b>Gift Name :</b> {gift.productName}
                          </p>
                          <p>
                            <b>Type :</b> {gift.orderType}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="gifts-table-stack">
                      <p>
                        <b>Salar Gift Credits :</b>{" "}
                        {formatGiftCurrency(gift.salarGiftCredits)}
                      </p>
                      <p>
                        <b>Validity :</b> {gift.validity}
                      </p>
                      <p className="gifts-inline-status-row">
                        <b>Status :</b>
                        {renderGiftStatus(gift.rewardStatus)}
                        {renderGiftStatus(gift.monthlyStatus)}
                      </p>
                    </div>
                  </td>
                  <td className="gifts-title-cell">
                    <span>
                      <Award size={28} strokeWidth={1.8} />
                    </span>
                    <strong>{gift.title}</strong>
                  </td>
                  <td className="gifts-receipt-cell">
                    <button
                      type="button"
                      onClick={() => navigate("/GiftDetails")}
                    >
                      <Download size={15} strokeWidth={2} />
                      Details
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="gifts-desktop-empty-cell" colSpan={7}>
                    <Gift size={27} strokeWidth={1.7} />
                    <strong>No gifts found</strong>
                    <span>You haven't won any gifts yet.</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="gifts-mobile-content">
        <div className="gifts-mobile-list">
          {records.length > 0 ? (
            records.map((gift) => (
              <button
                type="button"
                className="gifts-mobile-card"
                key={gift.id}
                onClick={() => navigate("/GiftDetails")}
              >
                <span className="gifts-mobile-serial">{gift.serialNo}</span>
                <div className="gifts-mobile-card-image">
                  <img src={gift.productImage} alt="" />
                </div>
                <div className="gifts-mobile-card-copy">
                  <span className="gifts-mobile-card-kicker">
                    {gift.milestone}
                  </span>
                  <h2>{gift.productName}</h2>
                  <p>Won {formatStuffLongDate(gift.orderDate)}</p>
                  <div className="gifts-mobile-card-bottom">
                    <span>Gift Status</span>
                    {renderGiftStatus(gift.giftStatus)}
                  </div>
                </div>
                <ChevronRight
                  className="gifts-mobile-card-chevron"
                  size={20}
                  strokeWidth={2}
                />
              </button>
            ))
          ) : (
            <div className="gifts-mobile-empty">
              <Gift size={32} strokeWidth={1.8} />
              <strong>No gifts found</strong>
              <span>Participate in Lucky Draws to win gifts.</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GiftsTable;
